import { useCallback } from 'react';
import usePushStore from '../store/toast.js'; 

export const usePushNotifications = () => {
  const addPush = usePushStore((state) => state.addPush);

  const addErrorPush = useCallback((text = 'Это информационное сообщение', timeout = 5000) => {
    addPush({
      type: 'error',
      title: 'Ошибка',
      message: text,
      timeout: timeout,
    });
  }, [addPush]);

  const addSuccessPush = useCallback((message, timeout = 5000) => {
    addPush({
      type: 'success',
      title: 'Информация',
      message: message,
      timeout: timeout,
    });
  }, [addPush]);

   const addWarningPush = useCallback((message, timeout = 5000) => {
    addPush({
      type: 'warning',
      title: 'Предупреждение',
      message: message,
      timeout: timeout,
    });
  }, [addPush]);

  return { addErrorPush, addSuccessPush, addWarningPush };
};